var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTacklLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326.2 88.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.5,38.6l15.2-16.9c.2-.2.4-.3.7-.3h20c.4,0,.7.4.7.8,0,.2,0,.4-.2.5l-21.6,22.5c-.4.4-.4,1.1,0,1.6l27.1,32.6c.2.2.1.5,0,.7,0,0-.2.1-.3.1h-19.4c-.3,0-.5-.2-.7-.4l-17.8-21.2c-.2-.3-.5-.3-.8-.2-2.3,1.2-3.4,3-3.3,5.8,0,5.2,0,10.4-.2,15.5,0,.3-.2.5-.5.5h-16.3c-.8,0-1.5-.7-1.5-1.6,0,0,0,0,0,0,.3-24.8.1-49.4-.1-74.2,0-1.3,0-2.2.2-2.8.2-.6.7-1,1.3-1l16.5-.2c.4,0,.5.2.5.5v37.6c0,.5.2.6.5.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 256.2,
    y: 0.4,
    width: 18.2,
    height: 79.7,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,36.8H3.1c-.3,0-.6-.4-.6-.7h0v-13.9c0-.4.3-.8.8-.8h6.5c.5,0,.8-.2.8-.8v-12.5c0-.3.3-.6.6-.6,0,0,0,0,0,0h17.2c.3.1.5.3.5.6v12.6c0,.4.2.6.6.6h10.5c.9,0,1.6.7,1.6,1.6h0v12.1c0,.8-.7,1.5-1.5,1.5h-10.5c-.4,0-.6.2-.6.6-.3,11.2-.3,19.3.1,24.4.4,4.7,8.9,3.2,11.7,2.2.3-.1.6,0,.7.4,0,0,0,.1,0,.2v14c0,.4-.2.7-.5.8-.6.3-1.5.5-2.5.7-14.7,3.3-27.7,0-27.9-17.7,0-8.3-.1-16.7,0-25.1,0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.4,25.5v-3.5c0-.4.2-.6.6-.6h16.6c.5,0,.8.2.8.8v57.4c0,.4-.2.6-.6.6h-16.6c-.5,0-.8-.2-.8-.7v-3.5c0-.2-.2-.4-.4-.4-.1,0-.2,0-.3.1-2.9,3.1-6.1,4.9-9.5,5.3-39.3,4.8-46.2-52.7-9.5-60.1,7.2-1.5,13.6.2,19.2,4.9.4.3.6.2.6-.3ZM90.3,39.8c-.2-.4-.6-.6-1.1-.6h-13c-.5,0-.9.2-1.1.6l-6.2,11.2c-.2.4-.2.9,0,1.2l6.2,10.9c.2.4.6.6,1.1.6h13c.5,0,.9-.2,1.1-.6l6.1-11c.2-.4.2-.8,0-1.2l-6.2-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178,66.6c.5.3.8.9.5,1.5,0,0,0,0,0,.1-6.2,9.7-16.9,14.1-28.3,12.7-18.2-2.3-29.9-17.6-26.7-35.7,4.5-25.7,41.4-34.8,55.1-11.3.2.4,0,.9-.3,1.1,0,0,0,0,0,0l-12.5,5.8c-.3.1-.6,0-.8-.1-7.2-6-18.4-6.1-22.7,3.2-7.1,15.3,10.4,28,22.6,16.8.3-.3.6-.3,1-.2l12.3,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.6,58.6h10.5c.6,0,1.2.3,1.5.9l5.4,9c.3.6.3,1.3,0,1.8l-5.4,9.3c-.3.5-.9.9-1.5.9h-10.3c-.6,0-1.2-.3-1.5-.9l-5.5-9.3c-.3-.6-.3-1.2,0-1.8l5.2-9c.3-.6.9-.9,1.5-.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTacklLogo);
export default __webpack_public_path__ + "static/media/TacklLogo.0c50489052df29f6ecb8a83628d14ca3.svg";
export { ForwardRef as ReactComponent };